/* eslint-disable no-console */
const isProduction = process.env.NODE_ENV === "production";
const isDevelopment = process.env.NODE_ENV === "development";

export const PROTOCOL = isProduction ? "https:" : "http:";
const ENV = isProduction ? "" : `${process.env.NODE_ENV}.`;
const PORT = isDevelopment ? ":8080" : "";

/**
 * Valid YourDictionary.com subdomains
 */
export const subdomains = {
    DEFINITIONS: "www",
    EXAMPLES: "examples",
    GRAMMAR: "grammar",
    QUOTES: "quotes",
    REFERENCE: "reference",
    SENTENCES: "sentence",
    SPANISH: "spanish",
    THESAURUS: "thesaurus",
    WEBSTERS: "websters",
    WORDFINDER: "wordfinder",
    WWW: "www",
    ES: "es",
    ABBREVIATIONS: "abbreviations",
    ESL: "esl",
    EDUCATION: "education"
};

/**
 * Google Analytics Trackers
 */

export const trackers = (() => {
    const subdomain = window.location.hostname.split(".")[0];
    const trackers = {
        aggregate: "UA-16913401-21",
        exceptions: (subdomain => {
            switch (subdomain) {
                case subdomains.WWW:
                    return "UA-16913401-34";
                case subdomains.DEFINITIONS:
                    return "";
                case subdomains.SENTENCES:
                    return "UA-16913401-19";
                case subdomains.EXAMPLES:
                    return "UA-16913401-15";
                case subdomains.THESAURUS:
                    return "";
                case subdomains.ES:
                    return "";
                case subdomains.ABBREVIATIONS:
                    return "";
                case subdomains.ESL:
                    return "";
                case subdomains.GRAMMAR:
                    return "";
                case subdomains.EDUCATION:
                    return "";
                case subdomains.REFERENCE:
                    return "";
                default:
                    console.error(`[Google Analytics] Missing tracker for subdomain ${subdomain}`);
                    return "";
            }
        })(subdomain),
        subdomain: (subdomain => {
            switch (subdomain) {
                case subdomains.THESAURUS:
                    return "UA-16913401-12";
                case subdomains.WWW:
                    return "";
                case subdomains.DEFINITIONS:
                    return "";
                case subdomains.SENTENCES:
                    return "";
                case subdomains.EXAMPLES:
                    return "";
                case subdomains.ES:
                    return "UA-16913401-35";
                case subdomains.ABBREVIATIONS:
                    return "UA-16913401-13";
                case subdomains.ESL:
                    return "UA-16913401-31";
                case subdomains.GRAMMAR:
                    return "UA-16913401-32";
                case subdomains.EDUCATION:
                    return "UA-16913401-30";
                case subdomains.REFERENCE:
                    return "UA-16913401-29";
                default:
                    console.error(`[Google Analytics] Missing tracker for subdomain ${subdomain}`);
                    return "";
            }
        })(subdomain),
        sanityCheck: "UA-16913401-1"
    };

    /**
     * Aggregate and Subdomain trackers are sampled to 1% and 100% respectively
     * Exceptions have been set to 10%
     * (See trackerSettings below). That's why we have a sanityCheck tracker
     * without any sampling (tracks 100% of hits).
     *
     * By PM requirement, this sanity check is only performed the 6th of
     * each month.
     */
    if (new Date().getUTCDate() !== 6) delete trackers.sanityCheck;
    if (trackers.exceptions == "") delete trackers.exceptions;
    if (trackers.subdomain == "") delete trackers.subdomain;
    return trackers;
})();

export const trackerSettings = {
    [trackers.aggregate]: { sampleRate: 1 },
    [trackers.exceptions]: { sampleRate: 10 },
    [trackers.subdomain]: { sampleRate: 100 }
};

/**
 * root object contains environment dependent links to all root subdomains for
 * YourDictionary. Please, use these links wherever you need to link to root.
 */
export const domain = `.${ENV}yourdictionary.com${PORT}`;
export const root = {
    EXAMPLES: `${PROTOCOL}//${subdomains.EXAMPLES}${domain}`,
    GRAMMAR: `${PROTOCOL}//${subdomains.GRAMMAR}${domain}`,
    QUOTES: `${PROTOCOL}//${subdomains.QUOTES}${domain}`,
    REFERENCE: `${PROTOCOL}//${subdomains.REFERENCE}${domain}`,
    SENTENCES: `${PROTOCOL}//${subdomains.SENTENCES}${domain}`,
    SPANISH: `${PROTOCOL}//${subdomains.SPANISH}${domain}`,
    THESAURUS: `${PROTOCOL}//${subdomains.THESAURUS}${domain}`,
    WEBSTERS: `${PROTOCOL}//${subdomains.WEBSTERS}${domain}`,
    WWW: `${PROTOCOL}//${subdomains.WWW}${domain}`,
    WORDFINDER: `https://wordfinder.yourdictionary.com`,
    ES: `${PROTOCOL}//${subdomains.ES}${domain}`,
    ABBREVIATIONS: `${PROTOCOL}//${subdomains.ABBREVIATIONS}${domain}`,
    ESL: `${PROTOCOL}//${subdomains.ESL}${domain}`,
    EDUCATION: `${PROTOCOL}//${subdomains.EDUCATION}${domain}`
};

/**
 * Superior limit (not included) for window.innerWidth for the device to be
 * considered as small. This is used for Ads.
 */
export const SMALL_DEVICE_WIDTH = 768;

/**
 * Limit for window.innerWidth for the device to be
 * considered as medium. This is used for Ads.
 */
export const MEDIUM_DEVICE_WIDTH = 1160;

/**
 * Minimum amount of time in milliseconds between versionService calls.
 */
export const VERSION_CHECK_POLL_FREQ = 30000;

/**
 * Errors
 */
export const VERSION_CHECK_ERROR = "VersionError";



// WEBPACK FOOTER //
// ./src/common/consts.js